<template>
  <div id="badminton_leagueTable" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>
    </div>
    <div class="teamList_area" ref="teamListArea" v-if="!isNotDataFlag">
      <!-- <div class="themeOperation_area">
          <span class="themeType_changeArea">
            <span
              class="themeType_item"
              v-for="item in themeTypeArr"
              :key="item.id"
              :class="item.act ? 'act' : ''"
              v-text="item.name"
              @click="changeThemeType(item)"
            ></span>
          </span>
        </div> -->
      <span class="groupTitle" v-text="groupTitle"></span>
      <div
        class="nodeTree_table_item"
        v-for="(table, index) in teamListGroup"
        :key="index"
      >
        <multiLevelFold_table
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :tableMode="tableMode"
          :parentWidthPx="nodeTree_table_parentWidthPx"
          :isScrollFlag="table.isScrollFlag"
          :variableColWidthVw="table.variableColWidthVw"
          :tableCellDefaultWidthVw="table.tableCellDefaultWidthVw"
          :defaultWidthVwNum="table.defaultWidthVwNum"
          :tableColumnData="table.tableColumnData"
          :tableData="table.tableData"
          :isBroadCastList="themeClass === 'onlyDisplay'"
          :sportCompetitionType="sportCompetitionType"
          v-show="nodeTree_table_parentWidthPx && teamListGroup.length >= 0"
        ></multiLevelFold_table>

        <span
          v-if="themeItem"
          class="nodeTree_table_publishBtn"
          @click="formatThemeActJson(table)"
        >
          <svg
            t="1692698307306"
            class="publishBtn_icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="9670"
            width="50%"
            height="50%"
          >
            <path
              d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
              p-id="9671"
            ></path>
          </svg>
        </span>
      </div>
    </div>
    <cup_notData v-if="isNotDataFlag" :className="'relativePt60'"></cup_notData>
  </div>
</template>

<script>
// import matchList_mock from './matchList_mock.json'
import {
  https_season_eventList,
  https_badminton_leagueTable,
} from '@api/platfrom_badminton_api'
import cup_base_data_mixin from '@mixins/cup_base_data'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
import cup_notData from '@components/base/NO_DATA.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import multiLevelFold_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
export default {
  name: 'badminton_leagueTable',
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  components: {
    cup_notData,
    marathon_select_opt,
    multiLevelFold_table,
  },
  data() {
    return {
      groupTitle: '',
      nodeTree_table_parentWidthPx: 0,
      teamListGroup: null,
      variableColWidthVw: 16.8,
      tableCellDefaultWidthVw: 5.55,
      dataItemId: null,
      isNotDataFlag: false,
      themeTemplateType: 30,
      curThemeItem: null,
      tableMode: 'combat_groupStage none',
      themeClass: 'onlyDisplay',
      // themeTypeArr: [
      //   {
      //     name: '积分榜',
      //     id: 'web',
      //     act: true,
      //   },
      //   {
      //     name: '实时积分榜',
      //     id: 'broadcast',
      //     act: false,
      //   },
      // ],
      eventArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'event',
            title: '组别',
            origin_keyVal: ['eventId', 'eventName'], // 源数据list [唯一id, 需要展示文字]
            dataName: 'eventArr', //this下面的存储该数据list字段名
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
    }
  },
  created() {
    if (this.currGroup) {
      this.init()
    }
    // this.themeTypeArr.forEach((item) => {
    //   if (item.act) {
    //     this.currThemeType = item
    //   }
    // })
  },
  mounted() {
    // console.debug(this.$refs)
    this.nodeTree_table_parentWidthPx = this.$refs.teamListArea.offsetWidth
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.getStageEvent()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      this.findAnalysisItemParams = {
        sportType: 'badminton',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: this.currStageEvent,
        pid: 0,
        mid: 0,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
    },
    findAnalysisItemCallback(resData) {
      // let themeAnalysisItemIdArr = []
      let jsonArr = []
      if (resData && resData.length > 0) {
        this.themeList = resData.map((item) => {
          // themeAnalysisItemIdArr.push(item.analysisItemId)
          // console.debug(`aa: ${item}`)
          jsonArr.push(item.json)
          item.actJson = JSON.parse(item.json)
          item.renderData = null
          return item
        })
        this.themeItem = this.themeList[0]
      } else {
        this.themeList = []
        this.themeItem = null
      }
    },
    onResizeEvent() {
      if (this.$refs.teamListArea) {
        this.nodeTree_table_parentWidthPx = this.$refs.teamListArea.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    // changeThemeType(btnItem) {
    //   this.themeTypeArr.forEach((item, index) => {
    //     if (item.id === btnItem.id) {
    //       item.act = true
    //       this.currThemeType = item
    //       this.curThemeItem = this.themeItemArr[index]
    //     } else {
    //       item.act = false
    //     }
    //   })
    // },
    formatThemeActJson(table) {
      if (!this.themeItem) return
      // 主题不同，有些地方需要特殊处理
      let orgTable = null
      if (table) {
        // 因为主题json里面的参数是动态的，表格数据给的key值和json里面的key值一样，因此从原始表格数据中取值，组装后的表格没有赋值全部原始表格key值
        this.origin_datas.forEach((originTable) => {
          if (table.seriesCode === originTable.groupCode) {
            orgTable = originTable
          }
        })
      }
      let keyArrActJson = []
      let newThemeItem = JSON.parse(JSON.stringify(this.themeItem))
      newThemeItem.actJson = JSON.parse(newThemeItem.json)
      keyArrActJson = Object.keys(newThemeItem.actJson)
      keyArrActJson.forEach((keyItem) => {
        newThemeItem.actJson[keyItem] = orgTable[keyItem]
      })
      console.debug('newThemeItem:', newThemeItem, orgTable)
      this.clickPublicTheme(newThemeItem)
      // if (!newThemeItem.analysisItemName) {
      //   // 有的主题有analysisItemName，有的没有，比如积分榜，因此处理一下，分享主题到公共播单的接口dataItemName都取这个字段
      //   newThemeItem.analysisItemName = newThemeItem.title
      // }
      // window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
      //   flag: true,
      //   themeItem: newThemeItem,
      // })
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = []
        if (config.isDatePicker) {
          // 日期选择框没有 dataName 属性
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: mix_id, //list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: this.currStageMatchDate ? this.currStageMatchDate : '', // 这个值是源数据需要展示的值，没有做过修改
            disabledArr,
            list,
            isDatePicker: config.isDatePicker,
          })
        } else {
          list = this[config.dataName].map((item) => {
            item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
            return item
          })
          console.debug(
            'computedSelectOpt 11:',
            config.type,
            config.dataName,
            this[config.dataName],
            list,
            mix_id
          )
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            isFilterable: config.isFilterable ? config.isFilterable : false,
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    async changeSelect(data) {
      console.debug('changeSelect:', data)
      let valPathArr = []
      let val = data.val
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'event') {
            this.currStageEvent = valPathArr[1]
            this.makeAnalysisItemParams(this.themeTemplateType)
            this.getLeagueTable({
              sid: this.currSid,
              eventId: this.currStageEvent,
            })
          } else {
          }
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    async getStageEvent() {
      await https_season_eventList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.eventArr = res.data && res.data.length > 0 ? res.data : []
            if (this.eventArr && this.eventArr.length > 0) {
              this.computedSelectOpt(this.selectOptData.configArr)
              this.currStageEvent = this.eventArr[0].eventId
              this.makeAnalysisItemParams(this.themeTemplateType)
              this.getLeagueTable({
                sid: this.currSid,
                eventId: this.currStageEvent,
              })
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getLeagueTable(query) {
      await https_badminton_leagueTable(this.axiosBaseUrl, this.$axios, query)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (
              !res.data.datas ||
              (res.data.datas && res.data.datas.length == 0)
            ) {
              this.isNotDataFlag = true
            }
            if (res.data.middle && res.data.middle.length) {
              console.debug('this.groupTable:', this.groupTable, res)
              const leftColumns = res.data.left
              const middleColumns = res.data.middle
              const rightColumns = res.data.right

              this.defaultWidthVwNum = res.data.middle.length
              let tableColumnData = []
              let leftColumnObjArr = []
              let rightColumnObjArr = []
              if (leftColumns) {
                for (let i = 0; i < leftColumns.length; i++) {
                  leftColumnObjArr.push({
                    prop: 'rankNum-teamLogo-teamName', //fristColumnPropArr.join('-'),
                    label: '球队',
                    widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                    className: 'rankNum-teamLogo-teamName', //单独定制的头部样式class
                    fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                  })
                }
              }

              tableColumnData = [].concat(leftColumnObjArr)
              for (let i = 0; i < middleColumns.length; i++) {
                const item = middleColumns[i]
                tableColumnData.push({
                  prop: item.colKey,
                  label: item.colTitle,
                  widthVw: this.tableCellDefaultWidthVw, //对应列的宽度，单位vw
                  className: '', //单独定制的头部样式class
                  selected: item.selected,
                })
              }
              tableColumnData.push({
                prop: '',
                label: '',
                widthVw: 3.74,
                selected: false,
              })

              if (rightColumns) {
                // for (let i = 0; i < rightColumns.length; i++) {
                //   rightColumnObjArr.push({
                //     prop: 'leftTeamName', //fristColumnPropArr.join('-'),
                //     label: '球队',
                //     widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                //     className: 'columnTeamNameClass', //单独定制的头部样式class
                //     fixed: 'right', //是否锁定，如果开启不滚动，此字段无效
                //   })
                // }
              }

              this.tableColumnData = [].concat(
                tableColumnData,
                rightColumnObjArr
              )
            }
            this.origin_datas = res.data.datas
            this.teamListGroup = res.data.datas
              ? res.data.datas.map((group, groupIndex) => {
                  let tableColumnData = JSON.parse(
                    JSON.stringify(this.tableColumnData)
                  )
                  tableColumnData.forEach((colItem, colIndex) => {
                    let newColItem = colItem
                    if (colIndex === 0) {
                      newColItem.label = group.groupName
                    }
                    return newColItem
                  })
                  console.debug('group:', group)
                  let singleTable = {
                    isScrollFlag: false,
                    variableColWidthVw: this.variableColWidthVw, // 可变化的宽度
                    tableCellDefaultWidthVw: this.tableCellDefaultWidthVw, // 默认宽度 ,
                    defaultWidthVwNum: this.defaultWidthVwNum,
                    // tableColumnData: [
                    //   {
                    //     prop: 'rankNum-teamLogo-teamName',
                    //     label: group.seriesName,
                    //     widthVw: 25.42,
                    //     className: 'columnNumLogoNameClass',
                    //     fixed: 'left',
                    //   },
                    //   {
                    //     prop: 'matchesPlayed',
                    //     label: '场次',
                    //     widthVw: 5.55,
                    //   },
                    //   {
                    //     prop: 'matchesWon',
                    //     label: '胜',
                    //     widthVw: 5.55,
                    //   },
                    //   {
                    //     prop: 'matchesDrawn',
                    //     label: '平',
                    //     widthVw: 5.55,
                    //   },
                    //   {
                    //     prop: 'matchesLost',
                    //     label: '负',
                    //     widthVw: 5.55,
                    //   },
                    //   {
                    //     prop: 'goalsFor',
                    //     label: '进球',
                    //     widthVw: 5.55,
                    //   },
                    //   {
                    //     prop: 'goalsAgainst',
                    //     label: '失球',
                    //     widthVw: 5.55,
                    //   },
                    //   {
                    //     prop: 'goalsDifference',
                    //     label: '净胜球',
                    //     widthVw: 5.55,
                    //   },
                    //   {
                    //     prop: 'points',
                    //     label: '积分',
                    //     widthVw: 5.55,
                    //   },
                    //   {
                    //     prop: '',
                    //     label: '',
                    //     widthVw: 4.16,
                    //   },
                    //   // {
                    //   //   prop: 'war',
                    //   //   label: '邮编12',
                    //   //   widthVw: 10,
                    //   //   fixed: 'right',
                    //   // },
                    // ],
                    tableColumnData,
                    tableData: group.teams.map((teamItem) => {
                      teamItem.team_name = teamItem.teamName
                      teamItem.team_logo = teamItem.teamLogo
                      teamItem.rank_num = teamItem.rankNum
                      return teamItem
                    }),
                    seriesCode: group.groupCode,
                    // analysisItemId: group.analysisItemId,
                    // json: group.json,
                    // seasonOrMatch: group.seasonOrMatch,
                    // title: group.title,
                  }
                  return singleTable
                })
              : []
            console.debug('teamListGroup:', this.teamListGroup)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
          // const res = {
          //   status: 0,
          //   message: 'success',
          //   data: [
          //     {
          //       seriesCode: '10168',
          //       seriesName: 'A组',
          //       dataList: [
          //         {
          //           rankNum: 1,
          //           teamId: 1054,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1054.png',
          //           teamName: '荷兰',
          //           matchesPlayed: 3,
          //           matchesWon: 2,
          //           matchesDrawn: 1,
          //           matchesLost: 0,
          //           goalsFor: 5,
          //           goalsAgainst: 1,
          //           goalsDifference: 4,
          //           points: 7,
          //         },
          //         {
          //           rankNum: 2,
          //           teamId: 1003,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1003.png',
          //           teamName: '塞内加尔',
          //           matchesPlayed: 3,
          //           matchesWon: 2,
          //           matchesDrawn: 0,
          //           matchesLost: 1,
          //           goalsFor: 5,
          //           goalsAgainst: 4,
          //           goalsDifference: 1,
          //           points: 6,
          //         },
          //         {
          //           rankNum: 3,
          //           teamId: 1053,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1053.png',
          //           teamName: '厄瓜多尔',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 1,
          //           matchesLost: 1,
          //           goalsFor: 4,
          //           goalsAgainst: 3,
          //           goalsDifference: 1,
          //           points: 4,
          //         },
          //         {
          //           rankNum: 4,
          //           teamId: 1058,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1058.png',
          //           teamName: '卡塔尔',
          //           matchesPlayed: 3,
          //           matchesWon: 0,
          //           matchesDrawn: 0,
          //           matchesLost: 3,
          //           goalsFor: 1,
          //           goalsAgainst: 7,
          //           goalsDifference: -6,
          //           points: 0,
          //         },
          //       ],
          //     },
          //     {
          //       seriesCode: '10169',
          //       seriesName: 'B组',
          //       dataList: [
          //         {
          //           rankNum: 1,
          //           teamId: 1027,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1027.png',
          //           teamName: '英格兰',
          //           matchesPlayed: 3,
          //           matchesWon: 2,
          //           matchesDrawn: 1,
          //           matchesLost: 0,
          //           goalsFor: 9,
          //           goalsAgainst: 2,
          //           goalsDifference: 7,
          //           points: 7,
          //         },
          //         {
          //           rankNum: 2,
          //           teamId: 1056,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1056.png',
          //           teamName: '美国',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 2,
          //           matchesLost: 0,
          //           goalsFor: 2,
          //           goalsAgainst: 1,
          //           goalsDifference: 1,
          //           points: 5,
          //         },
          //         {
          //           rankNum: 3,
          //           teamId: 1029,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1029.png',
          //           teamName: '伊朗',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 0,
          //           matchesLost: 2,
          //           goalsFor: 4,
          //           goalsAgainst: 7,
          //           goalsDifference: -3,
          //           points: 3,
          //         },
          //         {
          //           rankNum: 4,
          //           teamId: 1060,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1060.png',
          //           teamName: '威尔士',
          //           matchesPlayed: 3,
          //           matchesWon: 0,
          //           matchesDrawn: 1,
          //           matchesLost: 2,
          //           goalsFor: 1,
          //           goalsAgainst: 6,
          //           goalsDifference: -5,
          //           points: 1,
          //         },
          //       ],
          //     },
          //     {
          //       seriesCode: '10170',
          //       seriesName: 'C组',
          //       dataList: [
          //         {
          //           rankNum: 1,
          //           teamId: 1020,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1020.png',
          //           teamName: '阿根廷',
          //           matchesPlayed: 3,
          //           matchesWon: 2,
          //           matchesDrawn: 0,
          //           matchesLost: 1,
          //           goalsFor: 5,
          //           goalsAgainst: 2,
          //           goalsDifference: 3,
          //           points: 6,
          //         },
          //         {
          //           rankNum: 2,
          //           teamId: 1024,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1024.png',
          //           teamName: '波兰',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 1,
          //           matchesLost: 1,
          //           goalsFor: 2,
          //           goalsAgainst: 2,
          //           goalsDifference: 0,
          //           points: 4,
          //         },
          //         {
          //           rankNum: 3,
          //           teamId: 1009,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1009.png',
          //           teamName: '墨西哥',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 1,
          //           matchesLost: 1,
          //           goalsFor: 2,
          //           goalsAgainst: 3,
          //           goalsDifference: -1,
          //           points: 4,
          //         },
          //         {
          //           rankNum: 4,
          //           teamId: 1017,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1017.png',
          //           teamName: '沙特阿拉伯',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 0,
          //           matchesLost: 2,
          //           goalsFor: 3,
          //           goalsAgainst: 5,
          //           goalsDifference: -2,
          //           points: 3,
          //         },
          //       ],
          //     },
          //     {
          //       seriesCode: '10171',
          //       seriesName: 'D组',
          //       dataList: [
          //         {
          //           rankNum: 1,
          //           teamId: 1008,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1008.png',
          //           teamName: '法国',
          //           matchesPlayed: 3,
          //           matchesWon: 2,
          //           matchesDrawn: 0,
          //           matchesLost: 1,
          //           goalsFor: 6,
          //           goalsAgainst: 3,
          //           goalsDifference: 3,
          //           points: 6,
          //         },
          //         {
          //           rankNum: 2,
          //           teamId: 1026,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1026.png',
          //           teamName: '澳大利亚',
          //           matchesPlayed: 3,
          //           matchesWon: 2,
          //           matchesDrawn: 0,
          //           matchesLost: 1,
          //           goalsFor: 3,
          //           goalsAgainst: 4,
          //           goalsDifference: -1,
          //           points: 6,
          //         },
          //         {
          //           rankNum: 3,
          //           teamId: 1028,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1028.png',
          //           teamName: '突尼斯',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 1,
          //           matchesLost: 1,
          //           goalsFor: 1,
          //           goalsAgainst: 1,
          //           goalsDifference: 0,
          //           points: 4,
          //         },
          //         {
          //           rankNum: 4,
          //           teamId: 1021,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1021.png',
          //           teamName: '丹麦',
          //           matchesPlayed: 3,
          //           matchesWon: 0,
          //           matchesDrawn: 1,
          //           matchesLost: 2,
          //           goalsFor: 1,
          //           goalsAgainst: 3,
          //           goalsDifference: -2,
          //           points: 1,
          //         },
          //       ],
          //     },
          //     {
          //       seriesCode: '10172',
          //       seriesName: 'E组',
          //       dataList: [
          //         {
          //           rankNum: 1,
          //           teamId: 1012,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1012.png',
          //           teamName: '日本',
          //           matchesPlayed: 3,
          //           matchesWon: 2,
          //           matchesDrawn: 0,
          //           matchesLost: 1,
          //           goalsFor: 4,
          //           goalsAgainst: 3,
          //           goalsDifference: 1,
          //           points: 6,
          //         },
          //         {
          //           rankNum: 2,
          //           teamId: 1030,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1030.png',
          //           teamName: '西班牙',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 1,
          //           matchesLost: 1,
          //           goalsFor: 9,
          //           goalsAgainst: 3,
          //           goalsDifference: 6,
          //           points: 4,
          //         },
          //         {
          //           rankNum: 3,
          //           teamId: 1006,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1006.png',
          //           teamName: '德国',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 1,
          //           matchesLost: 1,
          //           goalsFor: 6,
          //           goalsAgainst: 5,
          //           goalsDifference: 1,
          //           points: 4,
          //         },
          //         {
          //           rankNum: 4,
          //           teamId: 1025,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1025.png',
          //           teamName: '哥斯达黎加',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 0,
          //           matchesLost: 2,
          //           goalsFor: 3,
          //           goalsAgainst: 11,
          //           goalsDifference: -8,
          //           points: 3,
          //         },
          //       ],
          //     },
          //     {
          //       seriesCode: '10173',
          //       seriesName: 'F组',
          //       dataList: [
          //         {
          //           rankNum: 1,
          //           teamId: 1023,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1023.png',
          //           teamName: '摩洛哥',
          //           matchesPlayed: 3,
          //           matchesWon: 2,
          //           matchesDrawn: 1,
          //           matchesLost: 0,
          //           goalsFor: 4,
          //           goalsAgainst: 1,
          //           goalsDifference: 3,
          //           points: 7,
          //         },
          //         {
          //           rankNum: 2,
          //           teamId: 1007,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1007.png',
          //           teamName: '克罗地亚',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 2,
          //           matchesLost: 0,
          //           goalsFor: 4,
          //           goalsAgainst: 1,
          //           goalsDifference: 3,
          //           points: 5,
          //         },
          //         {
          //           rankNum: 3,
          //           teamId: 1032,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1032.png',
          //           teamName: '比利时',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 1,
          //           matchesLost: 1,
          //           goalsFor: 1,
          //           goalsAgainst: 2,
          //           goalsDifference: -1,
          //           points: 4,
          //         },
          //         {
          //           rankNum: 4,
          //           teamId: 1059,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1059.png',
          //           teamName: '加拿大',
          //           matchesPlayed: 3,
          //           matchesWon: 0,
          //           matchesDrawn: 0,
          //           matchesLost: 3,
          //           goalsFor: 2,
          //           goalsAgainst: 7,
          //           goalsDifference: -5,
          //           points: 0,
          //         },
          //       ],
          //     },
          //     {
          //       seriesCode: '10174',
          //       seriesName: 'G组',
          //       dataList: [
          //         {
          //           rankNum: 1,
          //           teamId: 1019,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1019.png',
          //           teamName: '巴西',
          //           matchesPlayed: 3,
          //           matchesWon: 2,
          //           matchesDrawn: 0,
          //           matchesLost: 1,
          //           goalsFor: 3,
          //           goalsAgainst: 1,
          //           goalsDifference: 2,
          //           points: 6,
          //         },
          //         {
          //           rankNum: 2,
          //           teamId: 1004,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1004.png',
          //           teamName: '瑞士',
          //           matchesPlayed: 3,
          //           matchesWon: 2,
          //           matchesDrawn: 0,
          //           matchesLost: 1,
          //           goalsFor: 4,
          //           goalsAgainst: 3,
          //           goalsDifference: 1,
          //           points: 6,
          //         },
          //         {
          //           rankNum: 3,
          //           teamId: 1057,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1057.png',
          //           teamName: '喀麦隆',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 1,
          //           matchesLost: 1,
          //           goalsFor: 4,
          //           goalsAgainst: 4,
          //           goalsDifference: 0,
          //           points: 4,
          //         },
          //         {
          //           rankNum: 4,
          //           teamId: 1002,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1002.png',
          //           teamName: '塞尔维亚',
          //           matchesPlayed: 3,
          //           matchesWon: 0,
          //           matchesDrawn: 1,
          //           matchesLost: 2,
          //           goalsFor: 5,
          //           goalsAgainst: 8,
          //           goalsDifference: -3,
          //           points: 1,
          //         },
          //       ],
          //     },
          //     {
          //       seriesCode: '10175',
          //       seriesName: 'H组',
          //       dataList: [
          //         {
          //           rankNum: 1,
          //           teamId: 1015,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1015.png',
          //           teamName: '葡萄牙',
          //           matchesPlayed: 3,
          //           matchesWon: 2,
          //           matchesDrawn: 0,
          //           matchesLost: 1,
          //           goalsFor: 6,
          //           goalsAgainst: 4,
          //           goalsDifference: 2,
          //           points: 6,
          //         },
          //         {
          //           rankNum: 2,
          //           teamId: 1001,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1001.png',
          //           teamName: '韩国',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 1,
          //           matchesLost: 1,
          //           goalsFor: 4,
          //           goalsAgainst: 4,
          //           goalsDifference: 0,
          //           points: 4,
          //         },
          //         {
          //           rankNum: 3,
          //           teamId: 1016,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1016.png',
          //           teamName: '乌拉圭',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 1,
          //           matchesLost: 1,
          //           goalsFor: 2,
          //           goalsAgainst: 2,
          //           goalsDifference: 0,
          //           points: 4,
          //         },
          //         {
          //           rankNum: 4,
          //           teamId: 1055,
          //           teamLogo:
          //             'https://hyper-sports-res.mixtmt.com/football/team/1055.png',
          //           teamName: '加纳',
          //           matchesPlayed: 3,
          //           matchesWon: 1,
          //           matchesDrawn: 0,
          //           matchesLost: 2,
          //           goalsFor: 5,
          //           goalsAgainst: 7,
          //           goalsDifference: -2,
          //           points: 3,
          //         },
          //       ],
          //     },
          //   ],
          // }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#badminton_leagueTable {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
  }
  .teamList_area {
    width: 100%;
    padding: 2.083vw 0 2.778vw;
    .themeOperation_area {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 2.5vw;
      margin-bottom: 1.388vw;
      .themeType_changeArea {
        width: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        border: 1px solid var(--mixtmt_mainColor8);
        border-radius: 1.25vw;
        .themeType_item {
          width: 8.62vw;
          line-height: calc(2.5vw - 2px);
          text-align: center;
          color: var(--mixtmt_mainColor8);
          font-size: 0.972vw;
          &.act {
            background-color: var(--mixtmt_mainColor8);
            color: var(--mixtmt_whiteColor);
            &:first-child {
              border-radius: 1.25vw 0 0 1.25vw;
            }
            &:last-child {
              border-radius: 0 1.25vw 1.25vw 0;
            }
          }
        }
      }
      .themeBtn_area {
        flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        span {
          display: inline-block;
          margin-left: 0.972vw;
          line-height: calc(2.5vw - 2px);
          font-size: 1.11vw;
          padding: 0 0.972vw;
          border: 1px solid var(--mixtmt_greyColor7);
          color: var(--mixtmt_greyColor2);
          border-radius: 2px;
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
    .groupTitle {
      display: block;
      padding-bottom: 0.972vw;
      font-size: 1.388vw;
      line-height: 1.944vw;
      font-weight: bold;
      color: var(--mixtmt_greyColor3);
    }
    .nodeTree_table_item {
      position: relative;
      .nodeTree_table_publishBtn {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 2;
        width: 4.16vw;
        height: 3.332vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        svg.publishBtn_icon {
          fill: var(--mixtmt_table_publicBtnColor);
        }
      }
    }
  }
}
.mixtmt_pc #badminton_leagueTable,
.mixtmt_ipad #badminton_leagueTable {
}
.mixtmt_pc #badminton_leagueTable {
  .teamList_area {
    .themeOperation_area {
      .themeType_changeArea {
        .themeType_item {
          cursor: pointer;
          &:hover {
            background-color: var(--mixtmt_mainColor8);
            color: var(--mixtmt_whiteColor);
            &:first-child {
              border-radius: 1.25vw 0 0 1.25vw;
            }
            &:last-child {
              border-radius: 0 1.25vw 1.25vw 0;
            }
          }
        }
      }
      .themeBtn_area {
        span {
          cursor: pointer;
          &:hover {
            background-color: var(--mixtmt_mainColor8);
            color: var(--mixtmt_whiteColor);
          }
        }
      }
    }
    .nodeTree_table_item {
      .nodeTree_table_publishBtn {
        cursor: pointer;
        &:hover {
          svg.publishBtn_icon {
            fill: var(--mixtmt_subColor1_1);
          }
        }
      }
    }
  }
}
</style>
